// Module
var code = "<div class=\"flex layout-column layout-fill mn-pivot-container\" ng-class=\"{'empty-data': vm.emptyData,'incomplete-data':vm.incompleteData}\"\n     id=\"pivotElement\"></div>";
// Exports
module.exports = code;